// extracted by mini-css-extract-plugin
export default {"container":"aigenrator_container__xMgYN","title":"aigenrator_title__I7Qrg","selectCount":"aigenrator_selectCount__rKXoh"};